import React from 'react';
import {toast} from 'react-toastify';
import {t} from '@lingui/core/macro';

import {userAPI, IUser} from 'entities/user';
import Delete from 'shared/ui/icons/General/Delete';
import MainModal from 'shared/ui/Modal/MainModal';
import ModalBodyWrapper from 'shared/ui/Modal/ModalBodyWrapper';
import ModalBlockButton from 'shared/ui/Button/ModalBlockButton/ModalBlockButton';

import styles from './UserDeleteModal.module.scss';

interface IUserDeleteModalProps {
    item: IUser,
    open: boolean;
    handleClose: () => void;
}

const UserDeleteModal: React.FC<IUserDeleteModalProps> = ({ item, open, handleClose }) => {
    const [requestDeletion] = userAPI.useRequestUserDeletionMutation();

    const onClickDelete = async() => {
        try {
            await requestDeletion().unwrap();
            toast.info(t`Ссылка для подтверждения удаления отправлена на ваш email`);
            handleClose();
        } catch (err) {
        }
    };

    return (
        <MainModal
            header={t`Удаление аккаунта`}
            open={open}
            handleClose={handleClose}
            size="md"
            dialogClassName={styles.background}
        >
            <ModalBodyWrapper>
                <div className={styles.wrapper}>
                    <Delete width={64} height={64} />
                    <div className={styles.text}>
                        <span className={styles.title}>{t`Вы уверены, что хотите удалить аккаунт?`}</span>
                        <span className={styles.subTitle}>
                            {t`Вам будет отправлено письмо со ссылкой на подтверждение удаления аккаунта`} {item.email}
                        </span>
                    </div>
                </div>
            </ModalBodyWrapper>
            <ModalBlockButton
                primaryButtonText={t`Удалить`}
                primaryButtonType="submit"
                primaryButtonOnClick={onClickDelete}
                secondaryButtonOnClick={handleClose}
            />
        </MainModal>
    );
};

export default UserDeleteModal;